import ApplyBulkItemActionRequest from 'owa-service/lib/contract/ApplyBulkItemActionRequest';
import ApplyBulkItemActionResponse from 'owa-service/lib/contract/ApplyBulkItemActionResponse';
import BulkTriageActionType from 'owa-service/lib/contract/BulkTriageActionType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import applyBulkItemActionOperation from 'owa-service/lib/operation/applyBulkItemActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';
import KeepNType from 'owa-service/lib/contract/KeepNType';
import ApplyBulkItemActionJsonRequest from 'owa-service/lib/contract/ApplyBulkItemActionJsonRequest';
import applyBulkItemActionRequest from 'owa-service/lib/factory/applyBulkItemActionRequest';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SweepBulkActionCustomData } from 'owa-mail-sweep-store';

/**
 * Always delete conversation Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponse
 */
export default function alwaysDeleteConversationsService(
    emailAddresses: EmailAddressWrapper[],
    destinationFolderId: string,
    sourceFolderId: string,
    keepNType: KeepNType,
    keepNCount: number,
    customData?: SweepBulkActionCustomData
): Promise<ApplyBulkItemActionResponse> {
    const requestBody = applyBulkItemActionRequest(<ApplyBulkItemActionRequest>{
        ActionType: BulkTriageActionType.Move,
        DestinationFolderId: { Id: destinationFolderId },
        EmailAddresses: emailAddresses,
        SourceFolderId: { Id: sourceFolderId },
        CountType: keepNType,
        KeepNCount: keepNCount,
        BulkActionRequest:
            isFeatureEnabled('tri-bulkActionNotification') &&
            isFeatureEnabled('tri-sweepBulkAction'),
        BulkActionCustomData: customData && JSON.stringify(customData),
    });

    return applyBulkItemActionOperation(<ApplyBulkItemActionJsonRequest>{
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
